<app-loading></app-loading>
@if (showContent) {
  <div id="app-wrapper" [ngClass]="globalHeaderService.mobileClasses">
    @if (!isEnrolRoute() && authService.isAuthenticated() && authService.notParticipant()) {
      <app-side-nav></app-side-nav>
    }
    @if (!isEnrolRoute() && authService.isAuthenticated() && authService.notParticipant()) {
      <div class="page-title-container" [ngStyle]="getBannerBackground()" [ngClass]="{'sidenav-open': sideNavService.navIsOpen}">
        <div class="page-title-inner">
          <button type="button" (click)="sideNavService.toggleNav()" class="icon-button nav-toggle">
            <mat-icon [appThemed]="{'color': 'leftBannerIconColour'}" fontSet="etrainu-icon-regular" fontIcon="icon-menu"></mat-icon>
          </button>
          <h1 [appThemed]="{color: 'leftBannerIconColour'}" class="page-title">{{title}}</h1>
          <div class="flex-spacer"></div>
          <div class="global-actions">
            @if (globalHeaderService.showRefreshEvent && eventsService.selectedEvent) {
              <app-refresh-button [eventId]="eventsService.selectedEvent._id"
                (refreshComplete)="globalHeaderService.onMenuItemSelected({label: '', value: 'refresh-event'})"
                [disabled]="offlineService.isOffline"
                [appThemed]="{'color': 'rightBannerIconColour'}"
              ></app-refresh-button>
            }
            @if (authService.isAuthenticated()) {
              <div id="offline-switch">
                <button mat-icon-button (click)="offlineService.toggleOffline()">
                  <mat-icon [appThemed]="{'color': 'rightBannerIconColour'}" fontSet="etrainu-icon-bold" fontIcon="{{ (offlineService.isOffline) ? 'icon-wifi-off' : 'icon-wifi' }}"></mat-icon>
                </button>
              </div>
            }
            @if (globalHeaderService.menuItems.length > 0) {
              <button mat-icon-button data-testid="event-header-menu-trigger" [matMenuTriggerFor]="menu">
                <mat-icon [appThemed]="{'color': 'rightBannerIconColour'}" fontSet="etrainu-icon-regular" fontIcon="icon-more-vert"></mat-icon>
                <mat-menu #menu="matMenu">
                  @for (item of globalHeaderService.menuItems; track $index) {
                    <div mat-menu-item
                      (click)="globalHeaderService.onMenuItemSelected(item)"
                      [attr.data-testid]="'event-header-menu-item-' + item.label"
                      [ngClass]="{'disabled': item.disabled}"
                      >
                      <span>{{item.label}}</span>
                    </div>
                  }
                </mat-menu>
              </button>
            }
          </div>
        </div>
      </div>
    }
    <div class="main-content" id="app-content-container" [ngClass]="{'no-menu':  isEnrolRoute() || !authService.isAuthenticated() || !authService.notParticipant(), 'open-nav': sideNavService.navIsOpen}">
      <router-outlet></router-outlet>
    </div>
  </div>
}
